import type { DomainEvent } from "./domain-event"

export interface IEventBus {
  publish<T extends DomainEvent>(event: T): void
  subscribe<T extends DomainEvent>(eventType: string, handler: (event: T) => void): void
  unsubscribe<T extends DomainEvent>(eventType: string, handler: (event: T) => void): void
}

type EventHandler<T extends DomainEvent> = (event: T) => void

export class EventBus implements IEventBus {
  private subscribers = new Map<string, Set<EventHandler<DomainEvent>>>()

  publish<T extends DomainEvent>(event: T): void {
    const handlers = this.subscribers.get(event.type) ?? new Set()
    handlers.forEach((handler) => handler(event))
  }

  subscribe<T extends DomainEvent>(eventType: string, handler: EventHandler<T>): void {
    if (!this.subscribers.has(eventType)) {
      this.subscribers.set(eventType, new Set())
    }

    const handlers = this.subscribers.get(eventType)!
    handlers.add(handler as EventHandler<DomainEvent>)
  }

  unsubscribe<T extends DomainEvent>(eventType: string, handler: EventHandler<T>): void {
    const handlers = this.subscribers.get(eventType)
    if (handlers) {
      handlers.delete(handler as EventHandler<DomainEvent>)
    }
  }
}
